import { useQuery } from "@tanstack/react-query";
import { api, type models } from "jiffy-api";
import { objNamesToCamelCase, objNamesToSnakeCase } from "common/utils/helpers/cases";

export function useCanvaSettings(params: models.canva.settings.Request, enabled: boolean) {
  return useQuery({
    queryKey: ["canvaSettings", params],
    queryFn: () => api.canva.settings(objNamesToSnakeCase(params)).then(objNamesToCamelCase),
    enabled,
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
}
